module.exports = __webpack_public_path__ + "img/arrow-line.c2dc6444.svg";